import { Box, Divider } from "@mui/material";
import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";

export interface ITaskDynamicFormPageBreakProp {
    taskTypeCol: ITaskTypeCol;
}

export const TaskDynamicFormPageBreak = (_props: ITaskDynamicFormPageBreakProp) => {
    return (
        <Divider sx={{
            "&::before, &::after": {
                borderColor: "#000"
            }
        }}>
            <Box sx={{ padding: "8px 0" }}>
                {Translations.FormPageBreak}
            </Box>
        </Divider>
    );
};
